import { Routes } from '@angular/router'

import { LoginPageComponent } from './pages/login-page/login-page.component'
import { ResetPasswordPageComponent } from './pages/reset-password-page/reset-password-page.component'
import { EditPasswordPageComponent } from './pages/edit-password-page/edit-password-page.component'
import { ServerMaintenancePageComponent } from './pages/server-maintenance-page/server-maintenance-page.component'

export const routes: Routes = [
  {
    path: 'server-maintenance',
    component: ServerMaintenancePageComponent
  },
  {
    path: 'login',
    component: LoginPageComponent
  },
  {
    path: 'password/new',
    component: ResetPasswordPageComponent
  },
  {
    path: 'password/edit',
    component: EditPasswordPageComponent
  }
]
